<template>
  <div class="join">

    <el-card>
      <div  class="join-title">
        <h2>회원가입</h2>
      </div>
      <el-form
          :model="model"
          :rules="rules"
          class="join-form"
          ref="form"
          @submit.native.prevent="join"
      >
        <!-- @submit.native.prevent="join" -->
        <el-form-item prop="username">
           사업자명 (띄어쓰기 사용불가)
          <el-input v-model="model.username" placeholder="Username"  ></el-input>
        </el-form-item>


        <el-form-item prop="password">
          비밀번호 ( 4자리이상 )
          <el-input v-model="model.password" placeholder="Password" type="password"  ></el-input>
        </el-form-item>


        <el-form-item prop="password">
          비밀번호 확인
          <el-input v-model="model.password2" placeholder="Password 확인" type="password"   ></el-input>
        </el-form-item>


        <el-form-item prop="username">
          사업자번호 (- 제외)
          <el-input v-model="model.companyNumber" placeholder="사업자번호"  ></el-input>
        </el-form-item>


        <el-form-item prop="username">
          전화번호 (- 제외)
          <el-input v-model="model.telNo" placeholder="전화번호"  ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
              :loading="loading"
              class="join-button"
              type="warning"
              native-type="submit"
              block
              icon="el-icon-lock"
          >회원가입</el-button>
        </el-form-item>

        <!--           <a class="forgot-password" href="">Forgot password ?</a>-->
      </el-form>
    </el-card>


  </div>


</template>

<script>
import Axios from 'axios'

export default {
  name: "join",
  data() {
    return {
      validCredentials: {
        username: "admin",
        password: "1234"

      },
      loading: false,
      model: {
        username: "",
        password: "",
        password2 : "",
        companyNumber : "",
        telNo : "",
      },
      rules: {
        username: [
          {
            required: true,
            message: "Username is required",
            trigger: "blur"
          },
          {
            min: 3,
            message: "Username length should be at least 2 characters",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: "blur"
          },
          {
            min: 3,
            message: "Password length should be at least 3 characters",
            trigger: "blur"
          }
        ],
        password2: [
          {
            required: true,
            message: "Password is required",
            trigger: "blur"
          },
          {
            min: 3,
            message: "Password length should be at least 3 characters",
            trigger: "blur"
          }
        ],

        companyNumber: [
          {
            required: true,
            message: "사업자 번호 필수",
            trigger: "blur"
          },
          {
            min: 10,
            message: "사업자 번호 필수 10자리 확인",
            trigger: "blur"
          }
        ],

        telNo: [
          {
            required: true,
            message: "전화 번호 필수",
            trigger: "blur"
          },
          {
            min: 10,
            message: "전화 번호 자리수 확인",
            trigger: "blur"
          }
        ],

      }
    };
  },

  methods: {
    simulatejoin() {
      return new Promise(resolve => {
        setTimeout(resolve, 800);
      });
    },

    async beforeCheck(){

      if ( this.model.username.toLowerCase().trim() == ""  )
      {
        this.$message.error("사업자명을 입력해주세요 ");
        return false;
      }



      if ( this.model.password.toLowerCase().trim() != this.model.password2.toLowerCase().trim()  )
      {
        this.$message.error(" 비밀번호 확인이 다릅니다.  ");
        return false;
      }

      if ( this.model.password.toLowerCase().trim().length <= 3   )
      {
        this.$message.error(" 비밀번호는 3자리 이상입니다. ");
        return false;
      }

      if( this.model.username.toLowerCase().trim().indexOf(" ") != -1){
        this.$message.error(" 사업자명에 공백이 입력되었습니다. ");
        return false;
      }

      if( this.model.companyNumber.toLowerCase().trim().indexOf("-") != -1){
        this.$message.error(" 사업자 번호에 '-' 입력되었습니다. ");
        return false;
      }

      if( this.model.telNo.toLowerCase().trim().indexOf("-") != -1){
        this.$message.error(" 전화 번호에 '-' 입력되었습니다. ");
        return false;
      }

      return true;
    },

    async join() {

      let valid = await this.beforeCheck();
      if (!valid) {
        return;
      }


      this.loading = true;

      // default data
      let url = this.$url + '/UserInfo/insert' ;
      var reqJson = new Object();
      // reqJson.brand = this.brandOption;
      // reqJson.style = this.styleOption;
      // reqJson.dept_name = this.deptNameOption;
      // // reqJson.dept_seq = this.deptSeqOption;
      // reqJson.confirm_start_date = this.confirmStartDateOption;
      // reqJson.confirm_end_date = this.confirmEndDateOption;

      reqJson.user_id  = this.model.username.toLowerCase().trim();
      reqJson.user_name  = this.model.username.toLowerCase().trim() ;
      reqJson.password  = this.model.password.toLowerCase().trim() ;
      reqJson.accessToken  = "5" ;
      reqJson.company_number  = this.model.companyNumber.toLowerCase().trim() ;
      reqJson.tel_no  = this.model.telNo.toLowerCase().trim() ;

      await Axios.post(url, reqJson , this.$store.state.config ).then(res => {

        if (res.data.resultCode)
        {
          this.loading = false;
          this.$message.success("가입완료");
          this.$router.push({ name: 'Login' })

        }else{
          this.loading = false;
          this.$message.error(res.data.resultMessage);
        }
      }) // await Axios.post
          .catch(error => {
            console.log(error.response)
            this.$message.error(this.$store.state.serverErrorMessage);
            this.currentPage = 1;
            this.loading = false;
      }); // await Axios.post

    },//async join()

  },//methods

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.join-title {
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.join {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.join-icon {
  width: 10%;
  margin-top: 0px;
}

.join-username {
  width: 100%;
  margin-top: 0px;
}
.join-password {
  width: 100%;
  margin-top: 0px;
}



.join-form {
  width: 290px;
}
.forgot-password {
  margin-top: 0px;
}
</style>
<style lang="scss">
$teal: rgb(0, 124, 137);
.el-button--primary {
  background: $teal;
  border-color: $teal;

  &:hover,
  &.active,
  &:focus {
    background: lighten($teal, 7);
    border-color: lighten($teal, 7);
  }
}
.join .el-input__inner:hover {
  border-color: $teal;
}
.join .el-input__prefix {
  background: rgb(238, 237, 234);
  left: 0;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;
  .el-input__icon {
    width: 30px;
  }
}
.join .el-input input {
  padding-left: 35px;
}
.join .el-card {
  padding-top: 0;
  padding-bottom: 30px;
}
h2 {
  font-family: "Open Sans";
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
  padding-bottom: 20px;

}
a {
  color: $teal;
  text-decoration: none;
  &:hover,
  &:active,
  &:focus {
    color: lighten($teal, 7);
  }
}






.el-table {
  font-family: 'Segoe UI', 'Malgun Gothic';
  font-size: 9px !important;
}

.bg-purple-light {
  background: #f3f5f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

/* // 위에 검색 grid  간격  */
.el-row {
  margin-bottom: 0px;
}

.el-col {
  border-radius: 4px;
}

.el-table th>.cell {
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
}
.el-table .cell {

  display: flex !important;
  align-items: center !important;
  height: 30px !important;
  line-height: 30px;
}



.pagination{
  height: 52px !important;
  display: flex !important;
  align-items: center !important;
}

.el-button--primary {
  color: #FFF;
  background-color: #2C5AA0;
  border-color: #2C5AA0;
  height: 9px !important;
  display: flex !important;
  align-items: center !important;
  /* // margin-left: 20px !important; */
}

.el-input__inner {

  border-color: #2C5AA0 !important;
  height: 30px !important;

  font-size: 9px !important;
}

.searchTitle {
  height: 30px !important;
  width: 82px !important;
  font-size: 13px !important;
  align-items: center !important;
  margin-left: 10px !important;
  display: flex !important;
  /* // border: 1px solid #2C5AA0 !important; */
}

.searchBody {
  height: 30px !important;
  font-size: 10px !important;
  align-items: center !important;
  margin-left: 10px !important;
  display: flex !important;
  /* // background-color: #2C5AA0;
  // border: 1px solid #2C5AA0 !important; */
}

.searchBody_brand{
  width:50px !important;
  /* // border: 1px solid #2C5AA0 !important; */

}

.searchBody_year{
  width:50px !important;
  /* // border: 1px solid #2C5AA0 !important; */
  margin-left: 20px !important;
}

.searchBody_season{
  width:50px !important;
  /* // border: 1px solid #2C5AA0 !important; */
  margin-left: 20px !important;
}

.searchBody_production{
  width:50px !important;
  /* // border: 1px solid #2C5AA0 !important; */
  margin-left: 20px !important;
}

.el-input--mini .el-input__inner {
  height: 20px !important;
  width : 100px  !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;

}

.el-select .el-input.is-focus .el-input__inner {
  height: 20px !important;
  width : 100px  !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;
}
.el-select .el-input__inner {
  cursor: pointer;
  height: 20px !important;
  width : 100px  !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;
}




.el-select .el-input .el-select__caret {
  color: #2C5AA0;
  width:20px !important;
  height:20px !important;
  font-size: 9px !important;
  align-items: center !important;
  margin-left: 0px !important;
  display: flex !important;
}

.el-icon-arrow-up:before {

  margin-left: 3px !important;
  display: flex !important;
}

.el-select-dropdown__item.selected {
  color:  #2C5AA0 !important;
  font-size: 9px !important;
  font-weight: 0 !important;

}
*, ::after, ::before {
  font-size: 13px !important;
}

.el-input--prefix .el-input__inner {

  padding-left: 0px !important;
  cursor: pointer;
  height: 22px !important;
  width : 100px  !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 20px !important;

}

.el-icon-date:before {

  height: 22px !important;
  align-items: center !important;
  margin-top: 0px !important;
  margin-left: 0px !important;
  display: flex !important;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100px  !important;
}

.el-input__icon {
  line-height: 25px !important;
}


.searchBody_barcode{
  width:80px !important;
  margin-left: 20px !important;

}

.el-form-item__content {
   line-height: 20px !important;

}


</style>
